import { get, post, del } from 'src/integracoes/servicos/api/api-pgloader';
import { IMachine, SendCommandPayload, SendCommandResponse } from '../modelos/IMachine';
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';

export const obterMachinePorEmpresa = async (empId: string): Promise<IRespostaFuncao<IMachine>> => {
  return await get<IRespostaFuncao<IMachine>>(`api/machines/empresa/${empId}`);
};

export const criarMachine = async (payload: IMachine): Promise<IRespostaFuncao<IMachine>> => {
  return await post<IRespostaFuncao<IMachine>>(`api/machine/cria`, payload);
};

export const excluirMachine = async (
  id: string,
  userId: string,
  email: string
): Promise<IRespostaFuncao<IMachine>> => {
  return await del<IRespostaFuncao<IMachine>>(`api/machine/${id}`, { data: { userId, email } });
};

export const enviarComandoMaquina = async (
  id: string,
  command: string,
  userId: string,
  email: string,
  empId: string,
  whitelabel: string
) => {
  return await post<IRespostaFuncao<SendCommandResponse>>(`api/command/${id}`, {
    command,
    userId,
    email,
    empId,
    whitelabel
  });
};

export const congelarMachine = async (
  id: string,
  userId: string,
  email: string
): Promise<IRespostaFuncao<IMachine>> => {
  return await post<IRespostaFuncao<IMachine>>(`api/machine/congela/${id}`, { userId, email });
};
